var TemplateList = require('./core/template-list');

module.exports = new TemplateList();



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/cdb.templates.js
// module id = 1601
// module chunks = 6